import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormProvider } from 'react-hook-form';
import { faUser, faLock } from '@fortawesome/free-solid-svg-icons';
import { useAuthentification } from '../useAuthentification';
import { Field, PrimaryButton, Span, PageTitle } from '../../../common';
import { Form, Row, Col } from 'react-bootstrap';
import { Colors } from '../../../assets';

export const SignInForm = () => {
  const { methods, fields, handleSubmit, errors, authType, enableBasicAuth, kerberosError } =
    useAuthentification();

  return (
    <>
      <FormProvider {...methods}>
        <Form onSubmit={methods.handleSubmit(handleSubmit)}>
          {authType.basic && (
            <>
              <Row>
                <Col className="d-flex">
                  <Form.Group
                    className="mb-3 d-flex align-items-center w-100"
                    controlId="formUsername">
                    <FontAwesomeIcon
                      icon={faUser}
                      color={Colors.primary}
                      className="mr-4"
                      size="xl"
                    />
                    <Field {...fields.username} placeholder="Login" required />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex">
                  <Form.Group
                    className="mb-4 d-flex align-items-center w-100"
                    controlId="fromPassword">
                    <FontAwesomeIcon
                      icon={faLock}
                      color={Colors.primary}
                      size="xl"
                      className="mr-4"
                    />
                    <Field {...fields.password} type="password" placeholder="Heslo" required />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="mb-2 text-center">
                    {errors.username?.type === 'api' && (
                      <Span>{errors.username.message as string}</Span>
                    )}
                    {errors.username?.type === 'required' && (
                      <Span>Uživatelské jméno je povinné</Span>
                    )}
                    {errors.password?.type === 'required' && <Span>Heslo je povinné</Span>}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col className="text-center">
                  <PrimaryButton className="mb-3" type="submit">
                    Přihlásit
                  </PrimaryButton>
                </Col>
              </Row>
            </>
          )}
          {authType.kerberos && (
            <Row className="mb-5">
              <Col className="text-center">
                {!kerberosError && <PageTitle>Probíhá přihlašování pomocí Kerberos...</PageTitle>}
                {kerberosError && (
                  <Form.Group className="mb-2 text-center">
                    <Span>{kerberosError}.</Span>
                  </Form.Group>
                )}
              </Col>
            </Row>
          )}
          {authType.basicBtn && (
            <Row>
              <Col className="text-center">
                <PrimaryButton onClick={enableBasicAuth}>
                  Přihlásit se pomocí jména a hesla
                </PrimaryButton>
              </Col>
            </Row>
          )}
        </Form>
      </FormProvider>
    </>
  );
};
